export const categories: {
  title: string;
  description: string;
}[] = [
  {
    title: '産業発展',
    description:
      '進行する人口減少と高齢化の中で、地域資源の活用と雇用を通じた、地域コミュニティ及び地域経済・農林水産業の活性化に関連する取り組み。',
  },
  {
    title: '若者の希望',
    description:
      '不登校やいじめがきっかけで学びの機会を奪われてしまう課題の解決、将来への希望を持ち自分自身の生き方を支える取り組み。',
  },
  {
    title: '子育て環境',
    description:
      '子どもを産み育てやすい環境づくりを目的に、地域で子育て支援をする機会や携わる人々の負担削減に関連する取り組み。',
  },
  {
    title: '福祉の充実',
    description:
      '福祉サービスにおける人材確保や処遇改善、利用者の家族や従事者のサポートを通じて、福祉の充実に寄与する取り組み。',
  },
  {
    title: '地域の社会資本',
    description:
      'コミュニティが希薄化する中で、地域社会の連帯意識を強化し、地域コミュニティの関わり合い増加と活性化に関連する取り組み。',
  },
  {
    title: '多様性と働き方',
    description:
      '立場や性別に関係なく、個人の生き方や働き方が尊重されながら多様な選択肢を実現できる機会づくりに関連する取り組み。',
  },
];

type Props = {
  data: {
    category: string;
    value: number;
  }[];
};

export const SocialIssues = ({ data }: Props) => {
  return (
    <div className='flex flex-col items-center gap-16 bg-highlight px-[50px] py-16'>
      <p className='text-title-strong-medium text-accent'>解決を目指す東北の社会課題</p>
      <div className='flex max-w-[1000px] flex-row flex-wrap justify-center gap-4'>
        {categories.map((item, i) => (
          <div
            className='flex h-[336px] w-[320px] flex-col items-center gap-4 bg-white px-4 py-6'
            key={i}
          >
            <p className='text-title-strong-small'>{item.title}</p>
            <div className='flex w-full flex-col items-center bg-highlight py-1'>
              <p className='text-body-strong-large'>年間予算</p>
              <p className='text-body-strong-large'>
                <span className='text-en-title-strong-medium text-accent'>
                  {((): string => {
                    const v = data.find((d) => d.category === item.title)?.value;
                    return v ? (v / 10000).toLocaleString() : '0';
                  })()}
                </span>
                万
              </p>
            </div>
            <p className='text-center text-body-large'>{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
